import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { User } from '../models';
import { Observable } from 'rxjs';
import { BussinesService } from '../../public/services/bussines.service';
import { ProfileService } from './profile.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiService = inject(ApiService);
  private bussinesService = inject(BussinesService);
  private profileService = inject(ProfileService);

  storeUserApp(data: any) {
    data.createdBy = this.profileService.getProfile() as string;
    return this.apiService.store(`worker`, data);
  }

  deleteUser(id: number) {
    return this.apiService.delete(`worker`, id);
  }

  getUsers(): Observable<User[]> {
    return this.apiService.getAll('worker');
  }

  getUsersByBussines(idBussines?: number): Observable<User[]> {
    if (idBussines) {
      return this.apiService.getAll(`worker?businessid=${idBussines}`);
    } else {
      return this.apiService.getAll(`worker`);
    }
  }

  getUser(id: number): Observable<User> {
    return this.apiService.getById('worker', id);
  }

  updateUser(data: any, id: number) {
    let main = `worker/${data.worker_id}?firstname=${data.first_name}&lastname=${data.last_name}&username=${data.user_name}&usercode=${data.user_code}&email=${data.email}&second_email=${data.secondEmail}&phone=${data.phone}&address=${data.address}`;
    if (data.country_id) {
      main = main + `&countryId=${data.country_id}`;
    }
    if (data.workerGroupId) {
      main = main + `&workerGroupId=${data.workerGroupId}`;
    }
    if (data.buildingId) {
      main = main + `&buildingId=${data.buildingId}`;
    }
    return this.apiService.update(main, '', 1);
  }

  WithOutParking(BusinessId: number, workplaceId?: number): Observable<User[]> {
    console.log(BusinessId, ' - ', workplaceId);
    if (workplaceId) {
      return this.apiService.getAll(
        `worker/WithOutParking?businessId=${BusinessId}&workplaceId=${workplaceId}`
      );
    } else {
      return this.apiService.getAll(
        `worker/WithOutParking?businessId=${BusinessId}`
      );
    }
  }
}
